import { createGlobalStyle } from 'styled-components'

const CodeStylesMonokai = createGlobalStyle`
  .comment {
    color: #677A83;
  }
  .prolog {
    color: #6272a4;
  }
  .doctype {
    color: #6272a4;
  }
  .cdata {
    color: #6272a4;
  }
  .punctuation {
    // color: #E6DB74;
    color: #ffffff;
  }
  .namespace {
    opacity: .7;
  }
  .property {
    color: #57abe6;
    font-style: italic;
  }
  .tag {
    color: #F92672;
  }
  .constant {
    color: #AE81FF;
  }
  .symbol {
    color: #AE81FF;
  }
  .deleted {
    color: #AE81FF;
  }
  .boolean {
    color: #b67fff;
  }
  .number {
    color: #b67fff;
  }
  .selector {
    color: #94e400;
  }
  .attr-name {
    color: #A6E22E;
  }
  .string {
    color: #E6DB74;
  }
  .char {
    color: #AE81FF;
  }
  .builtin {
    color: #AE81FF;
  }
  .inserted {
    color: #AE81FF;
  }
  .operator {
    color: #f8f8f2;
  }
  .entity {
    color: #f8f8f2;
    cursor: help;
  }
  .url {
    color: #f8f8f2;
  }
  .language-css .token.string {
    color: #f8f8f2;
  }
  .token.unit {
    color: #ff0071;
  }
  .token.hexcode.color {
    color: #b67fff;
  }
  .style .token.string {
    color: #f8f8f2;
  }
  .variable {
    color: #f8f8f2;
  }
  .atrule {
    color: #A6E22E;
  }
  .attr-value {
    color: #E6DB74;
  }
  .function {
    color: #94e400;
  }
  .function-name {
    color: #94e400;
  }
  .class-name {
    color: #13dcf3;
    text-decoration: underline;
  }
  .keyword {
    color: #13dcf2;
  }
  .regex {
    color: #ffb86c;
  }
  .important {
    color: #ffb86c;
    font-weight: bold;
  }
  .bold {
    font-weight: bold;
  }
  .property-access {
    color: #ff0071!important;
  }
  .token.property-access {
    color: #94e400!important;
  }
`

export default CodeStylesMonokai
